import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import CustomCard from '../../../../components/card/CustomCard'
import {OutlinedButton, SemiTransparentButton} from '../../../../components/CustomButton'
import {
  getCommunities,
  getDoctorInfo,
  getSpecialities,
  verifyNmc
} from '../../../../redux/slices/doctorSlice'
import * as Scroll from 'react-scroll'

import Profile from './profile/Profile'
import Specialization from './specialization/Specialization'
import ExperienceEducationForm from './experienceAndEducation/ExperienceAndEducation'
import Communities from './communities/Communities'
import TableItemLoader from 'components/TableItemLoader'
import Male from '../../../../assets/avatar/male_doc.svg';
import Female from '../../../../assets/avatar/female_doc.svg';
import PropTypes from "prop-types";
import CustomCardHeader from "../../../../components/card/CustomCardHeader";
import {Tag} from "../../../../components/table/Status";
import {Avatar} from "../../../../components/table/ImageWrapper";
import CustomIcon from "../../../../components/CustomIcon";
import CardBody from '../../../../components/card/CardBody'
import { useParams } from 'react-router-dom';


CardBody.propTypes = {children: PropTypes.node};
const DoctorProfile = (props) => {
  const dispatch = useDispatch()
  const {doctor_id} = useParams();
  const Element = Scroll.Element
  const scroller = Scroll.scroller
  const [selectedOption, setSelectedOption] = useState('profile')

  const doctorData = useSelector((state) => state.doctor)

  useEffect(() => {
    fetchDoctorInfo()
    dispatch(getSpecialities())
    dispatch(getCommunities())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function scrollToPosition(e) {
    let name = e.target.getAttribute('name')
    setSelectedOption(name)
    if (name === 'profile') {
      scrollOptions('profile')
    } else if (name === 'specialities') {
      scrollOptions('specialities')
    } else if (name === 'education') {
      scrollOptions('education')
    } else if (name === 'experience') {
      scrollOptions('experience')
    } else {
      scrollOptions('communities')
    }

    function scrollOptions(name) {
      scroller.scrollTo(name, {
        duration: 1000,
        delay: 50,
        smooth: true,
      })
    }
  }

  const highlightSelectedOption = (option) => {
    return selectedOption === option
      ? 'cursor-pointer bg-secondary-100 text-secondary-500'
      : 'cursor-pointer'
  }
  const fetchDoctorInfo = () => {

    dispatch(getDoctorInfo(doctor_id))
  }

  return (
    <>
      <div className="px-3 md:px-8 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4 mb-16">
            <CustomCard className="bg-gray-100">
              <div className="w-full h-auto">
                {doctorData.loadingDoctorInfo ||
                doctorData.doctorInfo.length === 0 ? (
                  <TableItemLoader
                    loading={doctorData.loadingDoctorInfo}
                    error={doctorData.doctorInfoError}
                    isEmpty={doctorData.doctorInfo.length === 0}
                    retry={fetchDoctorInfo}
                    children={
                      <DoctorProfileLoader/>
                    }
                  />
                ) : (
                  <>
                    <DoctorCard doctor={doctorData.doctorInfo}/>
                    <CardBody>
                      <div className="flex justify-between w-full md:space-x-8 flex-col md:flex-row">
                        <aside className="sticky top-0 w-500">
                          <div className="flex md:flex-col flex-row overflow-auto">
                            <VerticalTabItem className={highlightSelectedOption('profile')}
                                             name="profile"
                                             onClick={scrollToPosition} label="Profile"/>
                            <VerticalTabItem className={highlightSelectedOption('specialities')}
                                             name="specialities"
                                             onClick={scrollToPosition} label="Specialization"/>
                            <VerticalTabItem className={highlightSelectedOption('experience')}
                                             name="experience"
                                             onClick={scrollToPosition} label="Experience"/>
                            <VerticalTabItem className={highlightSelectedOption('education')}
                                             name="education"
                                             onClick={scrollToPosition} label="Education"/>
                            <VerticalTabItem className={highlightSelectedOption('communities')}
                                             name="communities"
                                             onClick={scrollToPosition} label="Communities"/>
                          </div>
                        </aside>
                        <div className="flex-1 profile">
                          <Element name="profile">
                            <Profile
                              doctor={doctorData.doctorInfo}
                              isLoading={doctorData.loading}
                            />
                          </Element>
                          <Element name="specialities">
                            <Specialization
                              profile={doctorData.doctorInfo.doctor_profile}
                              specialities={doctorData.specialities}
                              error={doctorData.specialitiesError}
                              isLoading={doctorData.loadingSpecialites}
                            />
                          </Element>
                          <Element name="experience">
                            <ExperienceEducationForm
                              isEducation={false}
                              profile={doctorData.doctorInfo.doctor_profile}
                              isLoading={doctorData.loading}
                            />
                          </Element>
                          <Element name="education">
                            <ExperienceEducationForm
                              isEducation={true}
                              profile={doctorData.doctorInfo.doctor_profile}
                              isLoading={doctorData.loading}
                            />
                          </Element>
                          <Element name="communities">
                            <Communities
                              communities={doctorData.communities}
                              doctor={doctorData.doctorInfo}
                              error={doctorData.communitiesError}
                              isLoading={doctorData.loadingCommunity}
                            />
                          </Element>
                        </div>
                      </div>
                    </CardBody>
                  </>
                )}
              </div>
            </CustomCard>
          </div>
        </div>
      </div>
    </>
  )
}

const DoctorCard = ({doctor}) => {
  const dispatch = useDispatch()

  const verifyDoctor = () => {
    let payload = {
      id: doctor.id,
    }
    dispatch(verifyNmc(payload))
  }

  return (
    <CustomCardHeader contentPosition="none">
      <div className="w-full flex items-center space-x-4">
        <Avatar className="border-2 border-white"
                imageUrl={doctor?.profile_image === undefined ? doctor.gender === 'MALE' ? Male : Female : doctor.profile_image}/>
        <div className="w-full">
          <div className="flex justify-between">
            <h2 className="text-white text-2xl">
              {`Dr. ${doctor.first_name} ${doctor.middle_name ?? ''}  ${
                doctor.last_name
              }`}
            </h2>
            <div className="flex items-center text-sm space-x-2">
                <span
                  className={`flex items-center ml-1 text-xs ${doctor.status === "NMC_VERIFIED" ? "bg-primary-500" : "bg-amber-500"} px-2 py-1 rounded-full`}>
                  <CustomIcon className="mr-1" icon={doctor.status === "NMC_VERIFIED" ? "verified" : "history"}/>
                  NMC {doctor.status === "NMC_VERIFIED" ? "Verified" : "Pending"}
                </span>
              {doctor.status !== 'NMC_VERIFIED' && (
                <div>
                  <SemiTransparentButton
                    onClick={verifyDoctor}>Verify Doctor</SemiTransparentButton>
                </div>
              )}
            </div>

          </div>
          <div className="text-rand-100">
            {doctor?.doctor_profile?.specialization
              .map((specialization) => {
                return <Tag label={specialization?.label?.toUpperCase()}/>
              })
            }
          </div>
        </div>

      </div>
    </CustomCardHeader>
  )
}

const VerticalTabItem = ({className, name, onClick, label}) => {

  return (
    <div className={`${className ? className : ""} px-4 py-2 rounded-md my-2 text-sm`}
         name={name}
         onClick={onClick}>{label}
    </div>
  )
}
const DoctorProfileLoader = () => {

  return (
    <>
      <CustomCardHeader></CustomCardHeader>
      <div className="flex justify-between w-full md:space-x-8 flex-col md:flex-row p-4">
        <div className="flex md:flex-col flex-row">
          <div className="w-[118px] h-10 rounded-md my-2 bg-gray-200"/>
          <div className="w-[118px] h-10 rounded-md my-2 bg-gray-200"/>
          <div className="w-[118px] h-10 rounded-md my-2 bg-gray-200"/>
          <div className="w-[118px] h-10 rounded-md my-2 bg-gray-200"/>
          <div className="w-[118px] h-10 rounded-md my-2 bg-gray-200"/>
        </div>
        <div className="w-full">
          <div className="flex justify-between items-center mb-2 h-9">
            <div className="bg-gray-200 w-28 h-6"/>
            <OutlinedButton isIconButton={true} className="pointer-events-none border-gray-300">
              <CustomIcon icon="edit" className="text-gray-200"/>
            </OutlinedButton>
          </div>
          <div className="w-full h-[274px] rounded-md mb-8 bg-gray-200"/>
          <div className="flex justify-between items-center mb-2 h-9">
            <div className="bg-gray-200 w-28 h-6"/>
            <OutlinedButton isIconButton={true} className="pointer-events-none border-gray-300">
              <CustomIcon icon="edit" className="text-gray-200"/>
            </OutlinedButton>
          </div>
          <div className="w-full h-[66px] rounded-md bg-gray-200"/>

        </div>
      </div>
    </>
  )
}

DoctorCard.propTypes = {
  doctor: PropTypes.object.isRequired
}

export default DoctorProfile
